module.exports = __webpack_public_path__ + "static/img/blog.94b1159.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog.png
// module id = AdPx
// module chunks = 0